import React, { ReactNode } from 'react';
import { MdPrint } from "react-icons/md";
import '../styles/Sidebar.css';
import ReactToPrint from 'react-to-print';

/**
 * This is a generic sidebar component used with both function
 * and workflow/dataset documentation.
 * 
 * @author Juhana Kuparinen
 * @author Patrik Larsen
 */

const Sidebar = ({ children, contentRef  }: { children: ReactNode, contentRef: React.RefObject<HTMLInputElement>}) => {
  return (
    <div className='be_sidebar no-print'>
        <div className="be_sidebar-header">
          <h2>Table of Contents</h2>
              <ReactToPrint
        trigger={() =><button title="Print PDF"><MdPrint /></button>}
        content={() => contentRef.current}
      />
        </div>
        <ol className='be_chapter'>
          {children}
        </ol>
    </div>
  );
};

export default Sidebar;